import axios, { AxiosInstance } from 'axios';
import { localStorageManager, STORAGE_KEYS } from '../../utils/localStorage';

// API base URL from environment variable
const API_BASE_URL = process.env.REACT_APP_BE_BIP_URL || 'https://prod-be-bip.alpha-filter.xyz';

// axios instance
export const bipApiClient: AxiosInstance = axios.create({
  baseURL: `${API_BASE_URL}`,
  timeout: 60000, // 60 seconds
  headers: {
    'Content-Type': 'application/json',
  },
});

// Response interceptor - error handling
bipApiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('BIP API Error:', error);
    throw error;
  }
);

// Common header generation function
export const getBipAuthHeaders = () => {
  const apiKey = localStorageManager.getStringItem(STORAGE_KEYS.API_KEY);
  return {
    'X-API-Key': apiKey || '',
    'Content-Type': 'application/json',
  };
};
